import { render, staticRenderFns } from "./_Section6.vue?vue&type=template&id=d2faaf88&scoped=true&"
import script from "./_Section6.vue?vue&type=script&lang=js&"
export * from "./_Section6.vue?vue&type=script&lang=js&"
import style0 from "./_Section6.vue?vue&type=style&index=0&id=d2faaf88&scoped=true&lang=css&"
import style1 from "./_Section6.vue?vue&type=style&index=1&id=d2faaf88&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2faaf88",
  null
  
)

export default component.exports